import PowerBIReport from './PowerBIReport';

const BusinessInsightsReport = ({ reportName, businessId }: { reportName: string; businessId?: string }) => {
  if (!businessId) return null;

  return (
    <PowerBIReport
      reportName={reportName}
      filter={{ table: 'Deals Detail', column: 'businessId', value: businessId }}
      loadingText="Loading Business Insights..."
    />
  );
};

export default BusinessInsightsReport;